import ActionButton from 'components/ActionButton';
import BackButton from 'components/BackButton';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchSalesChannelDetails, fetchSalesChannelInventoryItems, syncMenuForSalesChannel, updatePosStatusOfUberSalesChannel } from 'services/api/salesChannel';
import { SALES_CHANNEL_TYPES, getPageLimit, showError, showSuccess, stringifyAndParseObj } from 'utils';
import { AddInventoryItemsToSalesChannel } from './addInventoryItems';
import SalesChannelAddress from './address';
import BasicDetails from './basicDetails';
import styles from './index.module.scss';
import InventoryItems from './inventoryItems';
import CopyCatalogue from './copyCatalogue';

const filters: { [p: string]: any; page: number } = {
  page: 0,
};

const SalesChannelDetails = (props) => {
  const { id } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [data, setData] = useState({}) as any;
  const [inventoryItems, setInventoryItems] = useState({}) as any;
  const [apiFilters, setApiFilters] = useState({});
  const [syncMenuLoading, setSyncMenuLoading] = useState(false);
  const [posStatusLoading, setPosStatusLoading] = useState(false);
  
  const fetchSalesChannelDetailsFn = async () => {
    setLoading(true);
    try {
      let response = await fetchSalesChannelDetails(id);
      response = stringifyAndParseObj(response);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchSalesChannelInventoryItemsFn = async () => {
    setInventoryItemsLoading(true);
    try {
      let response = await fetchSalesChannelInventoryItems({
        salesChannelId: id,
        page: filters?.page,
        limit: getPageLimit(),
        filters: apiFilters,
      });
      response = stringifyAndParseObj(response);
      setInventoryItems(response);
    } catch (e) {
      showError(e);
    } finally {
      setInventoryItemsLoading(false);
    }
  };

  const onClickSyncMenu = async() => {
    try {
      setSyncMenuLoading(true);
      const response = await syncMenuForSalesChannel({
        salesChannelId: id,
      });
      showSuccess(response);
    } catch (e) {
      showError(e);
    } finally {
      setSyncMenuLoading(false);
    }
  };

  const updatePosStatusOfUberSalesChannelFn = async() => {
    try {
      setPosStatusLoading(true);
      const response = await updatePosStatusOfUberSalesChannel({
        salesChannelId: id,
      });
      showSuccess(response);
    } catch (e) {
      showError(e);
    } finally {
      setPosStatusLoading(false);
    }
  };

  useEffect(() => {
    fetchSalesChannelDetailsFn();
  }, []);

  useEffect(()=>{
    fetchSalesChannelInventoryItemsFn();
  }, [apiFilters]);

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Sales Channel Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
      </div>
    </div>
  );

  const isSyncOperationAvailable = () => {
    return data?.apiProvider === SALES_CHANNEL_TYPES.UBER || data?.apiProvider === SALES_CHANNEL_TYPES.SHOPIFY;
  };

  const getActions = () => {
    return(
      <div className='mt-2'>
        <ActionButton
          text={'Edit'}
          active={true}
          isLoading={false}
          onClick={() => {
            props.history.push(`/sales-channels/${data?.objectId}/edit`);
          }}
        />
        <CopyCatalogue salesChannelId={id} />
        {isSyncOperationAvailable() && 
          <ActionButton
            text={'Sync Now'}
            active={!syncMenuLoading}
            isLoading={syncMenuLoading}
            onClick={onClickSyncMenu}
            customClass={'mt-2'}
          />
        }
        {data?.apiProvider === SALES_CHANNEL_TYPES.UBER && <ActionButton
          text={'Update POS Status'}
          active={!posStatusLoading}
          isLoading={posStatusLoading}
          onClick={updatePosStatusOfUberSalesChannelFn}
          customClass={'mt-2'}
        />}
      </div>
    );
  };

  return (
    <div id={'main-container'} className={`${styles['main-container']}`}>
      {loading && <Loading />}
      {getHeader()}
      {getActions()}
      <BasicDetails details={data} fetchSalesChannelDetailsFn={fetchSalesChannelDetailsFn} />
      <SalesChannelAddress details={data} setLoading={setLoading} fetchSalesChannelDetailsFn={fetchSalesChannelDetailsFn} />
      <AddInventoryItemsToSalesChannel 
        salesChannelId={id} 
        fetchSalesChannelInventoryItemsFn={fetchSalesChannelInventoryItemsFn}
        loading={inventoryItemsLoading}
      />
      <InventoryItems 
        salesChannelId={id} 
        inventoryItems={inventoryItems} 
        fetchSalesChannelInventoryItemsFn={fetchSalesChannelInventoryItemsFn}
        loading={inventoryItemsLoading}
        filters={filters}
        setApiFilters={setApiFilters}
        apiFilters={apiFilters}
        {...props}
      />
    </div>
  );
};

export default SalesChannelDetails;
